<div class="cadastro-mentorado-container">
  <div class="header">
    <h1>Cadastro de Mentorado</h1>
  </div>

  <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-cadastro">
    
    <!-- Dados Pessoais -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-user"></i>
        Dados Pessoais
      </h2>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="nome">Nome Completo *</label>
            <input 
              type="text" 
              id="nome" 
              class="form-control" 
              formControlName="NOME"
              placeholder="Digite seu nome completo">
            <div class="error-message" *ngIf="cadastroForm.get('NOME')?.invalid && cadastroForm.get('NOME')?.touched">
              Nome é obrigatório
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="telefone">Telefone *</label>
            <input 
              type="text" 
              id="telefone" 
              class="form-control" 
              formControlName="TELEFONE"
              placeholder="(11) 99999-9999">
            <div class="error-message" *ngIf="cadastroForm.get('TELEFONE')?.invalid && cadastroForm.get('TELEFONE')?.touched">
              Telefone é obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="email">Email *</label>
            <input 
              type="email" 
              id="email" 
              class="form-control" 
              formControlName="EMAIL"
              placeholder="seu@email.com">
            <div class="error-message" *ngIf="cadastroForm.get('EMAIL')?.invalid && cadastroForm.get('EMAIL')?.touched">
              Email válido é obrigatório
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dados do Projeto -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-graduation-cap"></i>
        Dados Acadêmicos
      </h2>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="cursoGraduacao">Curso de Graduação *</label>
            <input 
              type="text" 
              id="cursoGraduacao" 
              class="form-control" 
              formControlName="CURSO_GRADUACAO"
              placeholder="Ex: Engenharia de Software">
            <div class="error-message" *ngIf="cadastroForm.get('CURSO_GRADUACAO')?.invalid && cadastroForm.get('CURSO_GRADUACAO')?.touched">
              Curso de graduação é obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="nivelFormacao">Nível de Formação *</label>
            <select 
              id="nivelFormacao" 
              class="form-control" 
              formControlName="NIVEL_FORMACAO">
              <option value="">Selecione o nível</option>
              <option value="Graduacao">Graduação</option>
              <option value="Mestrado">Mestrado</option>
              <option value="Doutorado">Doutorado</option>
              <option value="Pos-doc">Pós-doc</option>
              <option value="Egresso">Egresso</option>
            </select>
            <div class="error-message" *ngIf="cadastroForm.get('NIVEL_FORMACAO')?.invalid && cadastroForm.get('NIVEL_FORMACAO')?.touched">
              Nível de formação é obrigatório
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="programaPosGraduacao">Programa de Pós-Graduação (PPG)</label>
            <input 
              type="text" 
              id="programaPosGraduacao" 
              class="form-control" 
              formControlName="PROGRAMA_POS_GRADUACAO"
              placeholder="Nome do programa de pós-graduação">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="instituicaoEnsino">Instituição de Ensino *</label>
            <input 
              type="text" 
              id="instituicaoEnsino" 
              class="form-control" 
              formControlName="INSTITUICAO_ENSINO"
              placeholder="Nome da instituição">
            <div class="error-message" *ngIf="cadastroForm.get('INSTITUICAO_ENSINO')?.invalid && cadastroForm.get('INSTITUICAO_ENSINO')?.touched">
              Instituição de ensino é obrigatória
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dados do Projeto -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-project-diagram"></i>
        Dados do Projeto
      </h2>
      
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="nomeProjeto">Nome do Projeto *</label>
            <input 
              type="text" 
              id="nomeProjeto" 
              class="form-control" 
              formControlName="NOME_PROJETO"
              placeholder="Título do seu projeto">
            <div class="error-message" *ngIf="cadastroForm.get('NOME_PROJETO')?.invalid && cadastroForm.get('NOME_PROJETO')?.touched">
              Nome do projeto é obrigatório
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="orientador">Orientador *</label>
            <input 
              type="text" 
              id="orientador" 
              class="form-control" 
              formControlName="ORIENTADOR"
              placeholder="Nome do orientador">
            <div class="error-message" *ngIf="cadastroForm.get('ORIENTADOR')?.invalid && cadastroForm.get('ORIENTADOR')?.touched">
              Orientador é obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="coOrientador">Co-orientador</label>
            <input 
              type="text" 
              id="coOrientador" 
              class="form-control" 
              formControlName="CO_ORIENTADOR"
              placeholder="Nome do co-orientador (se houver)">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="tipoProjeto">Tipo de Projeto *</label>
            <select 
              id="tipoProjeto" 
              class="form-control" 
              formControlName="TIPO_PROJETO">
              <option value="">Selecione o tipo</option>
              <option value="TCC">TCC</option>
              <option value="Dissertacao de Mestrado">Dissertação de Mestrado</option>
              <option value="Tese Doutorado">Tese de Doutorado</option>
              <option value="Projeto de Pesquisa">Projeto de Pesquisa</option>
              <option value="Projeto de Ensino">Projeto de Ensino</option>
              <option value="Projeto de Extensao">Projeto de Extensão</option>
            </select>
            <div class="error-message" *ngIf="cadastroForm.get('TIPO_PROJETO')?.invalid && cadastroForm.get('TIPO_PROJETO')?.touched">
              Tipo de projeto é obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="estagioProjeto">Estágio do Projeto *</label>
            <select 
              id="estagioProjeto" 
              class="form-control" 
              formControlName="ESTAGIO_PROJETO">
              <option value="">Selecione o estágio</option>
              <option value="Iteacao">Iteração</option>
              <option value="Planejamento">Planejamento</option>
              <option value="Execucao">Execução</option>
              <option value="Conclusao Parcial">Conclusão Parcial</option>
              <option value="Finalizacao">Finalização</option>
            </select>
            <div class="error-message" *ngIf="cadastroForm.get('ESTAGIO_PROJETO')?.invalid && cadastroForm.get('ESTAGIO_PROJETO')?.touched">
              Estágio do projeto é obrigatório
            </div>
          </div>
        </div>
      </div>


    </div>

    <!-- Botões de Ação -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="limparFormulario()">
        <i class="fas fa-times"></i>
        Limpar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="!cadastroForm.valid">
        <i class="fas fa-save"></i>
        Salvar Cadastro
      </button>
    </div>
  </form>
</div>

<!-- Template para o modal de busca de mentores -->
<ng-template #buscaMentoresModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-search"></i>
      Buscando Mentores Compatíveis...
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    
    <!-- Loading -->
    <div class="text-center" *ngIf="buscandoMentores">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Buscando...</span>
      </div>
      <p class="mt-3">Analisando seu perfil e buscando mentores compatíveis...</p>
    </div>

    <!-- Resultados -->
    <div *ngIf="!buscandoMentores && mentoresEncontrados.length > 0">
      <div class="alert alert-success">
        <i class="fas fa-check-circle"></i>
        <strong>Encontramos {{ mentoresEncontrados.length }} mentor(es) compatível(is) com seu perfil!</strong>
      </div>
      
      <div class="mentores-list">
        <div class="mentor-card" *ngFor="let mentor of mentoresEncontrados">
          <div class="mentor-header">
            <div class="mentor-avatar">
              <i class="fas fa-user-circle"></i>
            </div>
            <div class="mentor-info">
              <h6 class="mentor-name">{{ mentor.nome }}</h6>
              <p class="mentor-title">{{ mentor.titulo }}</p>
              <p class="mentor-institution">{{ mentor.instituicao }}</p>
            </div>
            <div class="match-score">
              <span class="badge bg-success">{{ mentor.matchScore }}% Match</span>
            </div>
          </div>
          
          <div class="mentor-details">
            <div class="row">
              <div class="col-md-6">
                <h6><i class="fas fa-graduation-cap"></i> Áreas de Atuação</h6>
                <ul class="areas-list">
                  <li *ngFor="let area of mentor.areas">{{ area }}</li>
                </ul>
              </div>
              <div class="col-md-6">
                <h6><i class="fas fa-chart-line"></i> Experiência</h6>
                <p>{{ mentor.experiencia }}</p>
                
                <h6><i class="fas fa-users"></i> Projetos Orientados</h6>
                <p>{{ mentor.projetosOrientados }} projetos</p>
              </div>
            </div>
            
            <div class="mentor-description">
              <h6><i class="fas fa-info-circle"></i> Sobre</h6>
              <p>{{ mentor.descricao }}</p>
            </div>
          </div>
          
          <div class="mentor-actions">
            <button class="btn btn-outline-primary btn-sm">
              <i class="fas fa-eye"></i>
              Ver Perfil Completo
            </button>
            <button class="btn btn-primary btn-sm">
              <i class="fas fa-handshake"></i>
              Solicitar Mentoria
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Nenhum resultado -->
    <div *ngIf="!buscandoMentores && mentoresEncontrados.length === 0" class="text-center">
      <div class="alert alert-warning">
        <i class="fas fa-exclamation-triangle"></i>
        <strong>Nenhum mentor compatível encontrado no momento.</strong>
        <p class="mb-0 mt-2">Tente novamente mais tarde ou entre em contato conosco.</p>
      </div>
    </div>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">
      <i class="fas fa-times"></i>
      Fechar
    </button>
    <button type="button" class="btn btn-primary" *ngIf="mentoresEncontrados.length > 0">
      <i class="fas fa-download"></i>
      Exportar Resultados
    </button>
  </div>
</ng-template>
